"use client";

import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import homeStyles from "../../Home.module.css";
import { HOME_AUDIENCES, renderMarked } from "./ForWho.logic";
import styles from "./ForWho.module.css";

export default function ForWho() {
  const T = useT();

  return (
    <div className={styles.container}>
      <div className={homeStyles.titles}>
        <h3 className={homeStyles.supTitle}>{T(TKey.HOME_TESTIMONIALS_SUP_TITLE)}</h3>
        <h2 className={homeStyles.statement}>
          <span className={styles.titleLine}>{T(TKey.HOME_TESTIMONIALS_TITLE)}</span>
          <span className={styles.titleLine}>{T(TKey.HOME_TESTIMONIALS_TITLE_2)}</span>
        </h2>
      </div>

      <div className={styles.grid}>
        {HOME_AUDIENCES.map((audience) => (
          <div className={styles.card} key={audience.titleKey}>
            <div className={styles.cardHeader}>
              <span className={styles.cardIcon}>{audience.icon}</span>
              <h3 className={styles.cardTitle}>{T(audience.titleKey)}</h3>
            </div>
            <p className={styles.cardText}>{T(audience.textKey)}</p>
            <p className={styles.cardAnswer}>
              {renderMarked(T(audience.answerKey), styles.cardMark)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
